// eslint-disable-next-line import/no-cycle
import { getApi } from '@/shared/api';

export default {
	namespaced: true,
	state: () => ({}),
	mutations: {},
	actions: {
		async getTariffRate(state, sum) {
			const response = await getApi(`/k5/v1/loan-app/get-rate?sum=${sum}`);
			return response;
		},
	},
};
